import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import { Typography, Button, useMediaQuery, Grid } from '@material-ui/core';

// CONSTANTS
import { ROUTE_DISCOVER, ROUTE_SUBSCRIPTION } from '@/constants/routes';

// UTILITY
import { getS3ImageUrl } from '@/utility/content';
import { getLink } from '@/utility/routes';

// COMPONENTS
import Link from '@/components/Link';

// STYLES
import { Container } from './styles';

const SMImg = getS3ImageUrl('/partner-tv/sm-section.png');
const SMImg2x = getS3ImageUrl('/partner-tv/sm-section-2x.png');
const RokuImg = getS3ImageUrl('/partner-tv/roku.png');
const RokuImg2x = getS3ImageUrl('/partner-tv/roku-2x.png');

const StreamingMarketplace = ({ partner }) => {
  const [t] = useTranslation();
  const downXs = useMediaQuery(({ breakpoints }) => breakpoints.down('xs'));

  const textOverwrites = partner?.text_overwrites || {};

  return (
    <Container className="section streaming-marketplace">
      <Grid container spacing={downXs ? 0 : 3}>
        <Grid item xs={12} md={partner?.settings?.show_roku_section ? 6 : 12}>
          <div className="streaming-marketplace__content">
            <div className="streaming-marketplace__img">
              <img srcSet={`${SMImg2x} 2x`} src={SMImg} alt="streaming-marketplace" />
            </div>
            <Typography className="text-bold m-b-15" component="h2" variant={downXs ? 'h5' : 'h3'}>
              {textOverwrites.tv_streaming_marketplace_title ||
                t('partnerHome.streamingMarketplace.title')}
            </Typography>
            <Typography className="m-b-15" variant="subtitle2">
              {textOverwrites.tv_streaming_marketplace_subtitle ||
                t('partnerHome.streamingMarketplace.subtitle')}
            </Typography>
            <Button
              className="streaming-marketplace__btn"
              to={ROUTE_DISCOVER}
              size={clsx(downXs ? 'medium' : 'large')}
              color="primary"
              component={Link}
              fullWidth={downXs}
            >
              {t('buttons.goShopping')}
            </Button>
          </div>
        </Grid>
        {partner?.settings?.show_roku_section && (
          <Grid item xs={12} md={6}>
            <div className="streaming-marketplace__content">
              <div className="streaming-marketplace__img streaming-marketplace__img--roku">
                <img srcSet={`${RokuImg2x} 2x`} src={RokuImg} alt="streaming-device" />
              </div>
              <Typography
                className="text-bold m-b-15"
                component="h2"
                variant={downXs ? 'h5' : 'h3'}
              >
                {textOverwrites.tv_streaing_device_title || t('partnerHome.streamingDevice.title')}
              </Typography>
              <Typography className="m-b-15" variant="subtitle2">
                {textOverwrites.tv_streaing_device_subtitle ||
                  t('partnerHome.streamingDevice.subtitle')}
              </Typography>
              <Button
                className="streaming-marketplace__btn"
                to={getLink(ROUTE_SUBSCRIPTION, { slug: 'roku_streaming_device' })}
                size={clsx(downXs ? 'medium' : 'large')}
                color="primary"
                component={Link}
                fullWidth={downXs}
              >
                {t('buttons.discoverRoku')}
              </Button>
            </div>
          </Grid>
        )}
      </Grid>
    </Container>
  );
};

StreamingMarketplace.propTypes = {
  partner: PropTypes.object.isRequired,
};

export default React.memo(StreamingMarketplace);
